import {RESTClient} from '../utils/rest';
import { writable } from 'svelte/store';
import User from './user';
import Modal from '../utils/modal';
import InviteModal from '../components/modal/InviteModal.svelte'
import qs from 'qs';
import CONFIG from '../utils/config';

let instance;
export class Matches extends RESTClient{
    

    async matches(group, next=false){
        if(next)
        return this.get('/match-schedules?_limit=1&DateTime_gt='+(new Date().toISOString())+'&_sort=DateTime:ASC&round='+group.round+'&groups='+group.id);
        else
        return this.get('/match-schedules?_sort=DateTime:ASC&round='+group.round+'&groups='+group.id);
    }

    static getInstance(){
        if(!instance){
            instance = new Matches();
        }
        return instance;
    }

}

export default Matches.getInstance();